import { render, staticRenderFns } from "./view-query-json-form.vue?vue&type=template&id=128e8218&scoped=true&"
import script from "./view-query-json-form.vue?vue&type=script&lang=js&"
export * from "./view-query-json-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128e8218",
  null
  
)

export default component.exports